const presentationModes = {
  LearnSubTopic: "learnSubTopic",
  LearnPrerequisite: "learnPrerequisite",
  GuidedPractise: "guidedPractise",
  Assessment: "assessment",
  ReviewMode: "reviewMode",
  Standalone: "standalone",
  factualMode: "factualMode",
};

const getPresentationModeBasedOnTask = (type) => {
  if (location.pathname.includes("review")) {
    type = presentationModes.ReviewMode;
  }
  switch (type) {
    case presentationModes.LearnSubTopic:
    case presentationModes.LearnPrerequisite:
    case presentationModes.GuidedPractise:
      return LearnSubTopic;
    case presentationModes.Assessment:
      return Assessment;
    case presentationModes.ReviewMode:
      return ReviewMode;
    case presentationModes.Standalone:
      return Standalone;
    case presentationModes.factualMode:
      return FactualMode;

    default:
      return LearnSubTopic;
  }
};

const LearnSubTopic = {
  DisplayCorrectAnswerInstantly: false,
  DisplayWrongAnswerInstantly: true,
  DisplayCorrectAnswerAfterNextClick: true,
  DisplayWrongAnswerAfterNextClick: true,
  DisplayAnswerInPurple: false,
};

const Assessment = {
  DisplayCorrectAnswerInstantly: false,
  DisplayWrongAnswerInstantly: false,
  DisplayCorrectAnswerAfterNextClick: false,
  DisplayWrongAnswerAfterNextClick: false,
  DisplayAnswerInPurple: true,
};
const ReviewMode = {
  DisplayCorrectAnswerInstantly: true,
  DisplayWrongAnswerInstantly: true,
  DisplayCorrectAnswerAfterNextClick: false,
  DisplayWrongAnswerAfterNextClick: false,
  DisplayAnswerInPurple: false,
};
const Standalone = {
  DisplayCorrectAnswerInstantly: false,
  DisplayWrongAnswerInstantly: true,
  DisplayCorrectAnswerAfterNextClick: true,
  DisplayWrongAnswerAfterNextClick: false,
  DisplayAnswerInPurple: false,
};
const FactualMode = {
  DisplayCorrectAnswerInstantly: false,
  DisplayWrongAnswerInstantly: false,
  DisplayCorrectAnswerAfterNextClick: true,
  DisplayWrongAnswerAfterNextClick: true,
  DisplayAnswerInPurple: false,
};
export {
  presentationModes,
  getPresentationModeBasedOnTask,
  LearnSubTopic,
  Assessment,
  ReviewMode,
  Standalone,
};
